import axios from 'axios'
import React from 'react'
import { ProfileActionTypes, ProjectTypes } from './profileReducer'

export const profileInit = async (dispatch: React.Dispatch<ProfileActionTypes>, rootUrl: string, callback: () => void): Promise<void> => {
  dispatch({ type: ProjectTypes.PROFILE_REQUEST })

  try {
    const response = await axios.get(
      '/api/profile',
      {
        withCredentials: false,
        baseURL: rootUrl,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('tokenSession')
        }
      })

    const profile: object = response.data as object

    dispatch({ type: ProjectTypes.PROFILE_SUCCESS, profileData: profile })

    if (callback) callback()
  } catch (error) {
    dispatch({ type: ProjectTypes.PROFILE_ERROR, profileError: 'Что то пошло не так, попробуйте обновить страницу' })
  }
}

export const profileLogout = (dispatch: React.Dispatch<ProfileActionTypes>): void => {
  dispatch({ type: ProjectTypes.PROFILE_LOGOUT })
}
